/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import Swiper from './lib/swiper';
import LinkHandler from './Classes/LinkHandler';
import Header from './Classes/Header';
import BackToTop from './Classes/BackToTop';
import PrevNextPosition from './Classes/PrevNextPosition';
import MobileSliderHandler from './Classes/MobilesliderHandler';
import SwitchHandler from './Classes/SwitchHandler';
import TableChartPopup from './Classes/TableChartPopup';

import Accordion from './Classes/Accordion';
import VideScrollSection from './Classes/VideScrollSection';
import ScrollAnimate from './Classes/ScrollAnimate';
import Video from './Classes/Video';
import Sticky from 'sticky-js';
import Headroom from './lib/headroom';
import SharesCSVHandler from './Classes/SharesCSVHandler';
import HeaderImg from "./Classes/HeaderImg";
import Animation from "./Classes/Animation";
import WOW from './lib/wow';
import LazyLoad from 'vanilla-lazyload';
import ColumnChart from './Classes/ColumnCharts';
import XDownloader from "./Classes/XDownloader";
import FocusHandler from './Classes/FocusHandler';


var lazyLoadInstance = null;
var headerInstance = null;
var headerImgInstance = null;
var videScrollSectionInstance = null;
var scrollAnimateInstance = null;
var accordionInstance = null;
var backToTopInstance = null;
var prevNextPositionInstance = null;
var videoInstance = null;
var mobileSliderInstance = null;
var switchHandlerInstance = null;
var linkHandlerInstance = null;
var tableChartPopupInstance = null;
var sliderInstance = null;

var stickyInstance = null;
var stickyHeaderInstance = null;
var animationInstance = null;
var wowInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  lazyLoadInstance = new LazyLoad();

  sliderInstance = new Swiper('.ns-slider__background', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  });

  new SharesCSVHandler();

  switchHandlerInstance = new SwitchHandler();

  mobileSliderInstance = new MobileSliderHandler({
    outerWrapperSelector: '.ns-mobile-slider',
    sliderBreakpoint: 992,
  });

  stickyInstance = new Sticky('.ns-video-section', {
    stickyContainer: '.ns-video-section-wrap',
    marginTop: document.querySelector('.header').offsetHeight,
    stickyClass: 'is-sticy'
  });

  stickyHeaderInstance = new Headroom(document.querySelector('.header__bottom'), {
    classes : {
      // when element is initialised
      initial : 'header__bottom',
      // when scrolling up
      pinned : 'header__bottom--pinned',
      // when scrolling down
      unpinned : 'header__bottom--unpinned',
      // when above offset
      top : 'header__bottom--top',
      // when below offset
      notTop : 'header__bottom--not-top is-sticky',
      // when at bottom of scroll area
      bottom : 'header__bottom--bottom',
      // when not at bottom of scroll area
      notBottom : 'header__bottom--not-bottom',
      // when frozen method has been called
      frozen: 'header__bottom--frozen'
    },
  });
  stickyHeaderInstance.init();

  //videScrollSectionInstance = new VideScrollSection();
  scrollAnimateInstance = new ScrollAnimate();

  linkHandlerInstance = new LinkHandler();

  headerInstance = new Header({
    submenuSelector: '.main-menu__wrap--level-1',
    submenuTogglerSelector: '.main-menu__item--has-children .main-menu__link--level-0',
    menuTogglerSelector: '.js-menu-toggle',
    menuContainerSelector: '.header__navigation'
  });

  headerImgInstance = new HeaderImg();

  backToTopInstance = new BackToTop();

  accordionInstance = new Accordion({
    accordions: '.js-toggle-accordion'
  });

  new FocusHandler();

  /*
  prevNextPositionInstance = new PrevNextPosition({
    footer: '.footer',
    prevnext: '.prev-next',
    header: '.header__bottom',
    breakPointMd: 990,
  });
   */

  videoInstance = new Video();

  tableChartPopupInstance = new TableChartPopup();

  animationInstance = new Animation({
    contentSelector: '.js-content-frontpage > *',
    wowInstance: wowInstance
  });

  animationInstance = new Animation({
    contentSelector: '.js-content-frontpage .ns-two-column-teaser',
    wowInstance: wowInstance
  });

  new ColumnChart(230, 10);

  new XDownloader({
    downloadText: "XLS", //Can be empty if you want to use an icon instead
    backgroundColor: "E2DED6", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-tabellenhg', //Class of colored cells
    borderColor: '000000', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-linie_fein'
  });

});
